import React from 'react'

const Light = () => {
	const pos1 = [-1, 2.4, -3]
	const pos2 = [-4, 2.4, -3]
	const pos3 = [-2, 5, 3]
	const pos4 = [-0.3, 2, 3.9]

	return (
		<>
			<ambientLight intensity="0.3" />
			<pointLight intensity="0.4" position={pos1} color="#DBB" />
			<pointLight intensity="0.3" position={pos2} color="#FEE" />
			<pointLight intensity="0.3" position={pos3} color="#FFDDBB" />
			<pointLight intensity="0.4" position={pos4} color="#FFF" />
		</>
	)
}

export default Light